import { Link } from '@mui/joy';
import { CaretRight } from '@phosphor-icons/react';
import { Link as RouterLink } from 'react-router-dom';

import { IBreadcrumbsItem } from 'core/types';

import { Breadcrumbs, Label, Text, Wrapper } from './breadcrumbsStyle';

interface IProps {
  breadcrumbs?: IBreadcrumbsItem[];
}

export const BreadcrumbsView = ({ breadcrumbs }: IProps) => {
  return (
    <Breadcrumbs separator={<CaretRight weight="bold" />} aria-label="breadcrumbs">
      {breadcrumbs?.map((item: IBreadcrumbsItem) => {
        const linkProps = item?.to
          ? { to: item?.to, component: RouterLink }
          : item?.onClick
          ? { onClick: item?.onClick }
          : {};

        const breadcrumbContent =
          item?.to || item?.onClick ? (
            <Link {...linkProps}>{item.text}</Link>
          ) : (
            <Text>{item.text}</Text>
          );

        return (
          <Wrapper key={item.text}>
            {item?.label && <Label>{item.label}:</Label>}

            {breadcrumbContent}
          </Wrapper>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsView;
